import { createFileRoute, notFound } from "@tanstack/react-router";
import Booking from "@/bookings/Booking";
import { ErrorComponent } from "@/components/Error";
import { NotFound } from "@/components/NotFound";
import { graphql } from "@/graphql";
import { apolloClient } from "@/lib/apollo-client";

export const Route = createFileRoute("/(authed)/_layout/bookings/$bookingId")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const { bookingId } = params;

    const { data } = await apolloClient.query({
      query: supplyChainBookingName,
      variables: {
        id: bookingId,
      },
    });
    if (!data?.supplyChainBooking) {
      throw notFound();
    }
    const bookingName = data ? `${data.supplyChainBooking?.name}` : "Booking Info";
    return {
      crumb: bookingName,
    };
  },
  notFoundComponent: (props) => (
    <NotFound
      title="Booking not found."
      message="The booking you are looking for does not exist."
      backToPath="/bookings"
      backToText="Back to bookings"
      {...props}
    />
  ),
  errorComponent: (props) => (
    <ErrorComponent
      title="Booking Error"
      message="There was a problem loading this booking."
      backTo={{
        path: "/bookings",
        text: "Back to bookings",
      }}
      {...props}
    />
  ),
});

function RouteComponent() {
  const { crumb } = Route.useLoaderData();
  return <Booking bookingName={crumb} />;
}

export const supplyChainBookingName = graphql(`
  query GetSupplyChainBookingName($id: UUID!) {
    supplyChainBooking(id: $id) {
      id
      name
    }
  }
`);
